import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import fileSize from 'filesize'
import { faDownload, faFileArchive, faFileExcel, faFilePdf, faFileWord } from '@fortawesome/free-solid-svg-icons'

import ConfigContext from '../../contexts/configContext'

import List from '../list'
import ListItem from '../listItem'

const getLogoByExtension = (extension) => {
  switch (extension) {
    case 'xlsx':
    case 'xls':
      return faFileExcel

    case 'doc':
    case 'docx':
      return faFileWord

    case 'pdf':
      return faFilePdf

    case 'bz2':
    case 'dmg':
    case 'gz':
    case 'gzip':
    case 'iso':
    case 'rar':
    case 'tar':
    case 'tgz':
    case 'zip':
      return faFileArchive

    default:
      return faDownload
  }
}

const AttachmentList = ({ classNamePrefix, documents }) => {
  const { mediaCDN } = useContext(ConfigContext)
  return (
    <List className={`list--borderless ${classNamePrefix}__list`}>
      {documents.map(document => {
        if (!document) return null
        const ext = document.publicId.split('.').pop()
        return (
          <ListItem key={`${classNamePrefix}__list-item--${document.publicId}`} className={`${classNamePrefix}__list-item`}>
            <a href={`${mediaCDN}/raw/upload/${document.publicId}`} target='_blank' rel='noreferrer noopener'>
              <FontAwesomeIcon icon={getLogoByExtension(ext)} className={`${classNamePrefix}__icon`} />
              {document.title} <small className='text-muted'>({document.size && fileSize(document.size)})</small>
            </a>
          </ListItem>
        )
      })}
    </List>
  )
}

AttachmentList.propTypes = {
  classNamePrefix: PropTypes.string,
  documents: PropTypes.arrayOf(PropTypes.shape({
    publicId: PropTypes.string.isRequired,
    size: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired
  })).isRequired
}

AttachmentList.defaultProps = {
  classNamePrefix: 'attachment'
}

export default AttachmentList
